<script>
import { CONSTANTS } from "@/helpers/constants";

export default {
  name: "TV360PaymentFaild",
  computed: {
    tid() {
      // Only read tid from the route query as requested
      return this.$route.query.tid || "";
    },
  },
  data() {
    return {};
  },
  methods: {
    goHome() {
      this.$router.replace("/home?tab=tabTV360");
    },
    color_primary() {
      return CONSTANTS.color_primary;
    },
  },
};
</script>

<template>
  <van-row>
    <van-col span="24">
      <div class="unsubscribe-content" style="background-color: #f5f8ff">
        <img class="image-successfull" src="@/static/report_problem_24px.png" />
        <div>
          <h4 class="unsubscribe-notify">{{ $t("failed") }}</h4>
          <p class="unsubscribe-description">
            {{ $t("tv360.payment_faild_1") }} {{ tid }}
            {{ $t("tv360.payment_faild_2") }}
          </p>
          <p class="unsubscribe-subdescription">
            {{ $t("tv360.payment_faild_3") }}
          </p>
        </div>
      </div>
    </van-col>
    <van-col span="24" class="cs-btn-bill van-payment-success">
      <van-button
        @click="goHome"
        :color="color_primary()"
        block
        class="btn-home"
        >{{ $t("home") }}</van-button
      >
    </van-col>
  </van-row>
</template>

<style>
.unsubscribe-content {
  margin: 16px;
  height: 412px;
  border-radius: 8px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  padding-top: 100px;
  gap: 20px;
  margin-bottom: 100px;
}

.image-successfull {
  width: 64px;
  height: 64px;
}

.unsubscribe-notify {
  color: #c41627;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0px;
}

.unsubscribe-description {
  color: #101828;
  text-align: center;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0;
  padding: 0 20px;
}

.unsubscribe-subdescription {
  color: #101828;
  text-align: center;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 0 20px;
}

.success {
  color: #0d993d !important;
}

.danger {
  color: #e53e3e !important;
}

.cs-btn-bill {
  display: flex !important;
  justify-content: center;
}

.van-payment-success {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 16px 16px 32px 16px;
}

.btn-home {
  max-width: 333px;
  max-height: 44px;
  border-radius: 8px;
}

.badge {
  padding: 0.4rem 0.375rem;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 50px;
  display: inline-block;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
}

.badge-success {
  background: #ecfdf3;
  color: #027a48;
}

.badge-danger {
  background: rgba(233, 22, 7, 0.1);
  color: #e81707;
}
</style>
